import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { closePopup } from '../../actions/uiActions';
import { deleteDatabase } from '../../actions/userActions';
import CloseIcon from '@mui/icons-material/Close';

class DeleteDatabase extends React.Component {

    handleDeleteDatabase = (event) => {
        event.preventDefault()
        this.props.deleteDatabase(this.props.popupInfo)

    }

    handleClick = (event) => {
        event.preventDefault()
        this.props.closePopup()
    }

    render() {
        let database = this.props.databaseList.find(x => x.id === this.props.popupInfo)
        return (<Dialog
            open={true}
            onClose={this.handleClick}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <CloseIcon onClick={this.handleClick} className="closePoup" />
            <DialogTitle id="alert-dialog-title" className="changepassdialog">
                {'Delete This Database Record?'}
                {' '}
            </DialogTitle>
            <DialogContent>
                
                    <div className="passwordResetbox">
                    <h5 className="DeletepepsiText">{database.server} - {database.dBname}</h5>
                        <button
                            className="btn"
                            onClick={this.handleDeleteDatabase}
                        >
                            Delete
                  </button>
                    </div>
               
            </DialogContent>
        </Dialog>
        )
    }
}

function mapStateToProps(state) {
    return {
        popupInfo: state.ui.popupInfo,
        databaseList: state.users.databaseList,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ closePopup, deleteDatabase }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DeleteDatabase)
